import React, { useEffect, useState } from 'react';

// Botón "Instalar Kontrol" del menú. En Android/Chrome/Edge abre la ventana
// de instalación del navegador; en iPhone/iPad explica cómo hacerlo desde
// Safari (Compartir → Agregar a inicio). Si ya está instalada, no se muestra.
const yaInstalada = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
const esIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent)
  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export default function InstalarApp({ className = 'k-item' }) {
  const [evento, setEvento] = useState(() => window.__instalarKontrol || null);
  const [guiaIOS, setGuiaIOS] = useState(false);
  const [instalada, setInstalada] = useState(yaInstalada);

  useEffect(() => {
    const listo = () => setEvento(window.__instalarKontrol || null);
    const hecha = () => { setInstalada(true); setEvento(null); };
    window.addEventListener('kontrol-instalable', listo);
    window.addEventListener('appinstalled', hecha);
    return () => { window.removeEventListener('kontrol-instalable', listo); window.removeEventListener('appinstalled', hecha); };
  }, []);

  if (instalada || (!evento && !esIOS())) return null;

  const instalar = async () => {
    if (evento) {
      evento.prompt();
      const { outcome } = await evento.userChoice.catch(() => ({}));
      if (outcome === 'accepted') setInstalada(true);
      window.__instalarKontrol = null;
      setEvento(null);
    } else {
      setGuiaIOS(true);
    }
  };

  return (
    <>
      <button className={className} onClick={instalar}>
        <span aria-hidden="true" style={{ width: '20px', textAlign: 'center' }}>📲</span>Instalar Kontrol
      </button>
      {guiaIOS && (
        <div role="dialog" aria-modal="true" aria-label="Instalar Kontrol en iPhone" onClick={() => setGuiaIOS(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 2000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', padding: '16px' }}>
          <div onClick={(e) => e.stopPropagation()}
            style={{ background: '#fff', color: '#1C1830', borderRadius: '18px', padding: '22px 20px', maxWidth: '420px', width: '100%', boxSizing: 'border-box', fontFamily: 'inherit' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
              <img src="/logo192.png?v=2" alt="" width="44" height="44" style={{ borderRadius: '11px' }} />
              <b style={{ fontSize: '17px' }}>Instala Kontrol en tu iPhone</b>
            </div>
            <ol style={{ margin: '0 0 14px', paddingLeft: '20px', fontSize: '15px', lineHeight: 1.6 }}>
              <li>Abre Kontrol en <b>Safari</b>.</li>
              <li>Toca el botón <b>Compartir</b> <span aria-hidden="true">(el cuadro con la flecha ⬆️)</span> abajo de la pantalla.</li>
              <li>Baja y toca <b>"Agregar a inicio"</b>.</li>
              <li>Toca <b>"Agregar"</b>. ¡Listo! Kontrol queda como app en tu pantalla.</li>
            </ol>
            <button onClick={() => setGuiaIOS(false)}
              style={{ width: '100%', padding: '12px', border: 'none', borderRadius: '12px', background: 'var(--color-primario,#6D28D9)', color: '#fff', fontWeight: 700, fontSize: '15px', fontFamily: 'inherit', cursor: 'pointer' }}>
              Entendido
            </button>
          </div>
        </div>
      )}
    </>
  );
}
